import { render, staticRenderFns } from "./BasketModal.vue?vue&type=template&id=436f7af1&scoped=true&"
import script from "./BasketModal.vue?vue&type=script&lang=js&"
export * from "./BasketModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436f7af1",
  null
  
)

export default component.exports